<template>
    <figure class="splash-container">
        <product-icon class="splash-icon"></product-icon>
    </figure>
</template>

<script setup lang="ts">
import ProductIcon from "@/scalar/product-icon.svg";
</script>

<style>
.splash-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.splash-icon {
    max-width: 40vw;
    max-height: 47vh;
}

@media screen and (min-width: 769px) {
    .splash-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        margin: 0;
    }
}
</style>
